export default __webpack_public_path__ + "static/11-6bfd51bca038ce415dab444b1bd2be54.webp";